



















import { editFactory } from '@/main/pages';
import { NdSklad } from '@/modules/sklad/ndSklad';
import { NdCenik } from '@/modules/sklad/ndCenik';
import mixins from 'vue-typed-mixins';
import { ShortcutMixin } from '@/main/mixins/shortcut';
import _ from 'lodash';
import { ERROR } from '@/main/store/actionTypes';
import { showAlert } from '@/main/utils/notifications';

import { store } from './store/edit';
import { NAME } from './constants';
import { editMutations } from './store/types';


export default mixins(ShortcutMixin, editFactory(NAME, store)).extend({
	components: {
		NdSkladSelect: NdSklad.components.Select,
		NdCenikSelect: NdCenik.components.Select,
	},
	data() {
		return {
			clearFilterNdNr: false,
		};
	},
	computed: {
		mnozstviFocus(): boolean {
			return (!_.isNil(this.NdNr));
		},
		ndSkladSelectFocus(): boolean {
			return this.isNdSkladSelectVisible && _.isNil(this.NdNr);
		},
		ndCenikSelectFocus(): boolean {
			return !this.isNdSkladSelectVisible && _.isNil(this.NdNr);
		},
		mutationsMapper(): Record<string, string> {
			return {
				ndSklad: `${this.storeUri}/${editMutations.ND_NR_MAPPER}`,
			};
		},
		ndskladFilter(): Record<string, any> {
			return {
				VyrobekndOzn: this.VyrobekndOzn,
				NdNr: this.clearFilterNdNr ? null : this.NdNr,
				NdText: this.Text,
				SkladOzn: this.SkladOzn,
			};
		},
		isNdSkladSelectVisible() {
			return !!this.SkladOzn;
		},
	},
	watch: {
		SkladOzn() {
			this.NdNr && this.checkNd();
		},
		VyrobekndOzn() {
			this.NdNr && this.checkNd();
		},
	},
	methods: {
		focused({ vueElement }: { vueElement: any }) {
			this.focusedElement = vueElement;
		},
		loadedData() {
			this.ZakazkaId = this.props.filter.ZakazkaId;
		},
		checkNd() {
			this.$nextTick(() => {
				this.clearFilterNdNr = true;
				if (this.isNdSkladSelectVisible) {
					(this.$refs.ndSelect as any).openGrid();
				} else {
					(this.$refs.cenikSelect as any).openGrid();
				}
			});
		},
		async addClick() {
			this.startLoading();
			const isPartBlockResponse = await NdSklad.apiProvider.isPartBlock(this.NdNr!, this.VyrobekndOzn!, this.Mnozstvi!);
			this.endLoading();
			if (isPartBlockResponse.data === true) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ErrPartBlock'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return;
			}
			try {
				this.startLoading();
				const saveResult = await this.save(false);
				if (saveResult instanceof Error) throw saveResult;
				this.resetState();

				await this.default(this.props.filter);
				this.$nextTick(() => {
					(this.mainForm as any).clearValidate();
				});
				this.refreshPreviousPage = true;
			} catch (err) {
				this.$store.dispatch(ERROR, { err }, { root: true });
			} finally {
				this.endLoading();
				this.$nextTick(() => {
					const element: any = (this.isNdSkladSelectVisible) ? this.$refs.ndSelect : this.$refs.cenikSelect;
					element.focusInput();
				});
			}
		},
		keyboardShortcutsHandler(shortcut: Record<string, any>) {
			if (shortcut.key === 'Enter') {
				const isNdNrSelect = this.focusedElement === this.$refs.ndSelect || this.focusedElement === this.$refs.cenikSelect;
				if (isNdNrSelect) {
					this.focusedElement.openGrid();
				} else if (this.focusedElement === this.$refs.mnozstvi) {
					this.addClick();
				}
			}
		},
	},
});
